import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import Head from 'next/head';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/** @description used to make sure the schema is in the head */
export const SGLinkedData = _ref => {
  let {
    item
  } = _ref;
  return item ? /*#__PURE__*/_jsx(Head, {
    "data-id": "json-ld_index_SGLinkedData_Head",
    children: /*#__PURE__*/_jsx("script", _objectSpread(_objectSpread({}, jsonLdScriptProps(item)), {}, {
      "data-id": "json-ld_index_SGLinkedData_Head_script"
    }))
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};